import { Component, OnInit, ViewChild, ElementRef, Renderer, Input, Output, EventEmitter } from '@angular/core';
import { flyInOut, fadeIn, fade, zFade, customPosition, animateOpen, rotateOpen, rotateDown, Cart, ProductInfo, Stock, CartStep, CartOverlay, CartBackdrop, steppedFly, steppedFlyX, storeFilters, storetitle,viewInfo,viewDesc,winkey,listAnimation,productAnim, slide, itemsfade } from '../animations';

import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectComponent } from 'ng-select';
import { Observable } from 'rxjs/Rx';

import { environment } from '../../environment';

import { StoreService } from '../../services/store.service';
import { UserService } from '../../services/user.service';

import { Currency } from '../../models/currency';
import { Product } from '../../models/product';
import { Category } from '../../models/category';
import { Account } from '../../models/account';
import { Item } from '../../models/item';
import { Filter } from '../../models/filter.constructor';

declare var $: any
declare var MasterSlider: any

@Component({
  selector: 'store',
  templateUrl: './store.component.html',
  providers: [ StoreService, UserService ],
  animations: [ flyInOut, fadeIn, fade, zFade, customPosition, animateOpen, rotateOpen, rotateDown, Cart, ProductInfo, Stock, CartStep, CartOverlay, CartBackdrop, steppedFly, steppedFlyX, storeFilters, storetitle, viewInfo, viewDesc, winkey, listAnimation, productAnim, slide, itemsfade ],
  inputs: ['updateCartButton', 'currentuser']
})

export class StoreComponent implements OnInit {

	@Input() updateCartButton: any;
	@Input() currentuser: any;
	
	@ViewChild('priceSort') priceSort: SelectComponent;
	@ViewChild('itemsSort') itemsSort: SelectComponent;
	@ViewChild('ProductsList') ProdusctList: ElementRef;
	@ViewChild('ItemsList') ItemsList: ElementRef;

	environment = environment;

	slider = true;
	flashCart = false;

	title: string;
	header: any;
	headerHeight: any;
	headerAlign: any;
	subtitle: string;
	currencyOpen: any;
	updateCart = true;
	loadingProducts = true;
	cartReset = false;

	currency: Currency;
	currencies: Currency;
	allproducts: Product;
	products: Product;
	allitems: Item;
	items: Item;

	selectedImage = 0;
	total: any;
	cart: any[];
	custom: any[];
	sidebar: any;
	numberOfProducts: number;
	numberOfItems: number;

	constructor(private storeService: StoreService,
				private userService: UserService,
				private route: ActivatedRoute,
				private sanitizer: DomSanitizer,
				private router: Router,
				private renderer: Renderer) {

	}

	matchHeight(parent: HTMLElement, className: string) {
        // match height logic here

        if (!parent) return;

        // step 1: find all the child elements with the selected class name
        const children = parent.getElementsByClassName(className);

        if (!children) return;

        // step 2a: get all the child elements heights
        const itemHeights = Array.from(children)
            .map(x => x.getBoundingClientRect().height);

        // step 2b: find out the tallest
        const maxHeight = itemHeights.reduce((prev, curr) => {
            return curr > prev ? curr : prev;
        }, 0);

        // step 3: update all the child elements to the tallest height
        Array.from(children)
            .forEach((x: HTMLElement) => x.style.height = `${maxHeight}px`);
    }


	getCart() {
		this.custom = this.storeService.getItemContents();
		this.cart = this.storeService.getCartContents();
		this.cartReset = ( this.cartReset == true ) ? false : true;
		this.flashCartButton();
	}

	getItemsCart() {
		setTimeout( () => {
			this.getCart();
		}, 100);
	}


	changeCurrency(currency) {
		this.currency = currency;
		this.storeService.changeCurrency(currency);
	}


	getProducts() {
		this.loadingProducts = true;
		Promise.resolve( this.storeService.loadProducts() ).then((storeproducts) => {
			this.products = storeproducts;
			this.allproducts = storeproducts;
			this.loadingProducts = false;
		});

		this.storeService.countProducts().subscribe( (length) => {
			this.numberOfProducts = length;
		});
	}

	flashCartButton() {
		this.flashCart = true;
		setTimeout( () => { this.flashCart = false;  }, 2000);
	}

    /* On with the show */
	ngOnInit() {

		this.title = 'IDENTITY STORE';
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/header-shop.jpg")' );
		this.subtitle = 'Changing what it means to be an MMORPG.';


		if ( environment.currencies ) {

			Promise.resolve(this.storeService.getCurrencies()).then((c) => {
				this.currencies = c;
			});
			Promise.resolve(this.storeService.getCurrency()).then((c) => {
				this.currency = c[0];
			});

		}

		/* 
		* Cart System
		*/
		this.getCart();

		Promise.resolve( this.storeService.getItems() ).then( (items) => {
			this.items = items;
		}); 

		$('html, body').animate({scrollTop: 0 }, 210);
  	}



  	ngAfterViewInit() {

		this.headerHeight = 780;

		/**
		 * Product Sliders 
		**/
		var slider = new MasterSlider();
		slider.setup('masterslider' , {
			width:1170,
			view:"flow",
			fullwidth:true,
			height: this.headerHeight,
			autoheight: true,
			loop: true,
			autoplay: false, // debugg = false
			keyboard: true,
			speed: 10,
			instantStartLayers: true,
			filters: {
				opacity: 0.7,
				brightness: 2
			}
		});

		slider.control('arrows');
		slider.control('bullets' , {autohide:false  , dir:"v", align:"bottom"});
  	}

}




// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/store/store/store.component.ts